import { combineReducers } from 'redux';
import idPassportReducer from './idPassportReducer';
import personalInformationReducer from './personalInformationReducer';
import fatcaCrsReducer from './fatcaCrsReducer';
import { ACTION_TYPE } from '../actions/actionTypes';

const { APPLICANT } = ACTION_TYPE;

const applicantReducer = (state = {}, action) => {
  switch (action.type) {
    case APPLICANT.SAVE_PROOF_OF_TRANSFER:
      return { ...state, proofOfTransfer: action.payload };
    case APPLICANT.SAVE_PACI_FRONT_STATUS:
      return { ...state, paciFrontStatus: action.payload };
    case APPLICANT.REF_CODE:
      return { ...state, imarkazRefCode: action.payload };
    case APPLICANT.OTHER_APPLICATION_DETAILS:
      return {
        ...state,
        completionDate: action.payload.completionDate,
        currentLoggedIn: action.payload.currentLoggedIn,
        lastLoggedIn: action.payload.lastLoggedIn,
      };
    case APPLICANT.REWORK_STATUS:
      return { ...state, rework: action.payload };
    case APPLICANT.CREATE_APPLICANT:
      return { ...state, applicantId: action.payload.applicantId, phoneNumber: action.payload.phoneNumber };
    case APPLICANT.APPLICANT_FAIL:
      return { ...state, error: action.payload };
    case APPLICANT.UPDATE_APPLICANT_SUCCESS:
      return {
        ...state,
        applicantId: action.payload.applicantId,
        phoneNumber: action.payload.phoneNumber,
        applicantPhoneNumbers: action.payload.applicantPhoneNumbers,
        // emailSent: action.payload.emailSent,
        imarkazRefCode: action.payload.imarkazRefCode,
        // applicantStatus: action.payload.applicantStatus,
        // username: action.payload.username,
        // email: action.payload.email,
        error: null,
      };
    case APPLICANT.APPLICANT_PDF:
      return { ...state, crmUrl: action.payload, pdfError: null };
    case APPLICANT.APPLICANT_PDF_GENERATED:
      return { ...state, pdfGenerated: action.payload, pdfError: null };
    case APPLICANT.APPLICANT_FATCA_PDF:
      return { ...state, fatcaUrl: action.payload, pdfError: null };
    case APPLICANT.APPLICANT_TC_PDF:
      return { ...state, tcUrl: action.payload, pdfError: null };
    case APPLICANT.APPLICANT_CRS_PDF:
      return { ...state, crsUrl: action.payload, pdfError: null };
    case APPLICANT.APPLICANT_NDPF_PDF:
      return { ...state, ndpfUrl: action.payload, pdfError: null };

    /** Proposed Allocation */
    case APPLICANT.APPLICANT_ALLOCATION_PDF:
      return { ...state, allocationUrl: action.payload, pdfError: null };
    case APPLICANT.APPLICANT_IREP_PDF:
      return { ...state, irepUrl: action.payload, pdfError: null };

    /** Uploaded Asset Allocation by MARKAZ ADMIN */
    case APPLICANT.APPLICANT_ASSET_ALLOCATION_PDF:
      return { ...state, assetAllocationUrl: action.payload, pdfError: null };

    /** Investment Strategy PDFs */
    case APPLICANT.APPLICANT_DPF_PDF:
      return { ...state, dpfUrl: action.payload, pdfError: null };
    case APPLICANT.APPLICANT_INVESTMENT_STRATEGY_ABSOLUTE_PDF:
      return { ...state, investmentStrategyAbsoluteUrl: action.payload, pdfError: null };
    case APPLICANT.APPLICANT_INVESTMENT_STRATEGY_ABSOLUTE_SHARIA_PDF:
      return { ...state, investmentStrategyAbsoluteShariaUrl: action.payload, pdfError: null };

    /** Custody main contract */
    case APPLICANT.APPLICANT_CPF_PDF:
      return { ...state, cpfUrl: action.payload, pdfError: null };

    /** Custom sub agreements */
    case APPLICANT.APPLICANT_CUSTOM_SUB_AGREEMENT:
      return { ...state, customFileUrls: action.payload, pdfError: null }; // customFileUrls should be an array of pdf urls

    /** THIS IS TO REPLACE Custom sub Agreements with the new one */
    case APPLICANT.APPLICANT_CUSTOM_SUB_PORTFOLIO:
      return { ...state, customSubPfUrl: action.payload, pdfError: null };

    case APPLICANT.APPLICANT_DIVIDEND_YIELD:
      return { ...state, dividendUrl: action.payload, pdfError: null };

    case APPLICANT.APPLICANT_MFT_PDF:
      return { ...state, mftUrl: action.payload, pdfError: null };
    case APPLICANT.APPLICANT_PDF_FAIL:
      return { ...state, pdfError: action.payload };
    case APPLICANT.SEND_EMAIL_SUCCESS:
      return { ...state, emailSent: action.payload, sentError: null };
    case APPLICANT.SEND_EMAIL_FAIL:
      return { ...state, emailSent: false, sentError: action.payload };
    case APPLICANT.APPLICANT_PDF_REFRESH:
      return { ...state, pdfRefreshed: action.payload };
    case APPLICANT.SAVE_LATEST_REF_CODE:
      return { ...state, latestRefCode: action.payload };

    case APPLICANT.PRODUCT_CODE:
      return { ...state, productCode: action.payload };

    default:
      return state;
  }
};

const applicantRootReducer = combineReducers({
  applicantReducer,
  idPassportReducer,
  personalInformationReducer,
  fatcaCrsReducer,
});

export default applicantRootReducer;
